module.exports = __webpack_public_path__ + "static/media/banner-Web2.da3a3fba.jpg";